import {
  Breadcrumbs,
  Card,
  Container,
  List,
  Section,
  Stack,
} from "@storoey/sui";
import { createFileRoute, useNavigate } from "@tanstack/solid-router";
import { For, onMount } from "solid-js";
import { useNavbar } from "../../../../contexts/RootContext";

export const Route = createFileRoute("/history/$formId/$categoryId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const loaderData = Route.parentRoute.useLoaderData();
  const { setTitle } = useNavbar();
  const navigate = useNavigate();

  onMount(() => {
    setTitle(loaderData().category.title);
  });

  return (
    <Section
      padding="lg"
      breadcrumbs={
        <Container>
          <Breadcrumbs>
            <Breadcrumbs.Item onClick={() => navigate({ to: `/` })}>
              Hjem
            </Breadcrumbs.Item>
            <Breadcrumbs.Item onClick={() => navigate({ to: `/history` })}>
              Historie
            </Breadcrumbs.Item>
            <Breadcrumbs.Item
              onClick={() =>
                navigate({ to: `/history/` + loaderData().formId })
              }
            >
              {loaderData().formName}
            </Breadcrumbs.Item>
            <Breadcrumbs.Item current>
              {loaderData().category.title}
            </Breadcrumbs.Item>
          </Breadcrumbs>
        </Container>
      }
    >
      <Container>
        <Stack>
          <Card elevation={200}>
            <Card.Content>
              <Card.Title>{loaderData().category.title}</Card.Title>
            </Card.Content>
            <Card.Actions>
              <List>
                <For each={loaderData().sections}>
                  {(section) => (
                    <List.Item
                      // trailingText={Intl.DateTimeFormat("no-NB", {
                      //   dateStyle: "short",
                      // }).format(category.)}
                      trailingIcon="chevron_right"
                      trailingText={`${section.itemCount}`}
                      onClick={() =>
                        navigate({
                          to: `./${section.id}`,
                        })
                      }
                    >
                      {section.title}
                    </List.Item>
                  )}
                </For>
              </List>
            </Card.Actions>
          </Card>
        </Stack>
      </Container>
    </Section>
  );
}
